import React from 'react';
import $ from 'jquery';

class LandSearchSorting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onSortClicked: props.onSort,
            onViewClicked: props.onSwitch,
            mobileSort: null
        };
        this.viewClicked = this.viewClicked.bind(this);
        this.sortClicked = this.sortClicked.bind(this);
        this.mobileSortClicked = this.mobileSortClicked.bind(this);
    }

    componentDidMount() {
        let p = this.props.search;
        if('sortby' in p && 'sort' in p) {
            this.state.onSortClicked(p.sortby, p.sort);
        }
    }

    viewClicked(view, ev) {
    	$('.land-filter-section').toggleClass('land-search-grid');
        this.state.onViewClicked(view);
    }

    sortClicked(type, ev) {
        if($(ev.target).is('.active','.sort'))  {
			$('.sort_button').removeClass('active');
			$(ev.target).addClass('active');

		} else if($(ev.target).is('.active')) {
        	console.log('second reset');
			$('.sort_button').removeClass('.active');
			$(ev.target).addClass('active');

		}
		else{
			$('.sort_button').removeClass('active');
			$('.sort_button').children().removeClass('active');
        	$(ev.target).addClass('active');

		}

        $(ev.target).toggleClass('sort');
        var dir = 'dsc';
        if($(ev.target).hasClass('sort')) {
        	dir = 'asc';
		}

		if(dir === 'asc') {
			$(ev.target).children().addClass('active');
		}else {
			$(ev.target).children().removeClass('active');
		}

        this.state.onSortClicked(type, dir);
    }

    mobileSortClicked(ev) {
        let select = $(ev.target).val();
        select = select.split(" ");
        if(select.length === 2) {
            this.state.onSortClicked(select[0], select[1]);
        }
    }

    render() {
        let listClass = "m-l-2";
        let gridClass = "search-not-active cursor-hover";
        if(this.props.view === 'grid') {
            listClass = "m-l-2 search-not-active cursor-hover";
            gridClass = "";
        }
        return (
            <div className="brd-top land-search-list-header">
                <div className="cf">
                    <div className="land-search-list-header-left fl">
                        <div className="w-30 fl tl p-l-2-lg">
                            <div className="w-100 fl">
                                <p>Lot number</p>
                            </div>
                        </div>

                        <div className="w-30-lg w-30-md w-40 fl tc-lg tl">
                            <div className="w-33-lg w-100 fl m-b-05 m-b-0-wd small-grey-font tc">
                                <button className="sort_button" onClick={(ev) => this.sortClicked('price', ev)}><img src="https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/chevron-down.svg"
                                    alt="" width="15px" />&nbsp;&nbsp; Price
                                </button>
                            </div>

                            <div className="w-33-lg w-100 fl m-b-05 m-b-0-wd small-grey-font tc">
                                <button className="sort_button" onClick={(ev)=> this.sortClicked('frontage', ev)}><img
                                    src="https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/chevron-down.svg"
                                    alt="" width="15px" />&nbsp;&nbsp;Frontage
                                </button>
                            </div>

                            <div className="w-33-lg w-100 fl m-b-05 m-b-0-wd small-grey-font tc">
                                <button className="sort_button" onClick={(ev) => this.sortClicked('area', ev)}><img
                                    src="https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/chevron-down.svg"
                                    alt="" width="15px" />&nbsp;&nbsp;Land Size
                                </button>
                            </div>
                        </div>
                    </div>
					{this.props.view === 'list' ? (
						<div className="land-pps-col fl tc">
							<p>PPS</p>
						</div>
					) : null}
					<div className="w-20-lg w-20 fl tc-lg tl land-search-packages">

						<div className="w-50-lg w-100 fl">
							<p className="">Packages</p>
						</div>
						<div className="w-50-lg w-100 fl tc">

						</div>

					</div>
					<div className="land-search-enquire-spacer"></div>
					<div className="w-60 fl tr dn-lg">
						<div className="sortby-mobile">
							<select onChange={this.mobileSortClicked}>
								<option>SORT BY</option>
								<option value="frontage dsc">Frontage (High)</option>
								<option value="frontage asc">Frontage (Low)</option>
								<option value="area dsc">Land Size (High)</option>
								<option value="area asc">Land Size (Low)</option>
								<option value="price dsc">Price (High)</option>
								<option value="price asc">Price (Low)</option>
							</select>
						</div>
					</div>

					<div className="land-search-view-toggle w-15-wd w-10-lg w-40 fr tr">
						<a onClick={(ev) => this.viewClicked('grid',ev)} className={gridClass}>
							<img className="grid-icon" src="https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/grid-icon.svg" alt=""/>
						</a>

						<a onClick={(ev) => this.viewClicked('list',ev)} className={listClass}>
							<img className="list-icon" src="https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/list-icon.svg" alt=""/>
						</a>
					</div>
                </div>
            </div>
        )
    }
}

export default LandSearchSorting;


/** WEBPACK FOOTER **
 ** ./src/modules/common/LandSearchSorting.js
 **/